<template>

    <a @click="openExternalLink()" :href="popupItem.url" target="_blank" class="ecm-item-card">

        <h2 class="ecm-item-card-address">{{ popupItem.address }}</h2>
        <p class="ecm-item-card-city">{{ popupItem.district }}, {{ popupItem.city }}</p>

        <img v-if="popupItem.image" :src="popupItem.image" alt="" />

        <div class="ecm-item-card-price-and-size">
            <div v-if="popupItem.price" class="ecm-item-card-price">{{ popupItem.price }}</div>
            <div v-if="popupItem.size" class="ecm-item-card-size">{{ popupItem.size }} m<sup>2</sup></div>
        </div>

        <p class="ecm-item-room-configuration">
            {{ popupItem.roomConfiguration }}
        </p>

        <p class="ecm-item-building-type">
            {{ popupItem.buildingType }}, {{ popupItem.year }}
        </p>

        <p class="ecm-item-card-read-more">
            {{ $t("readMore") }}
        </p>

    </a>

</template>

<script>
import { eventBus } from '../../main.js';
//import { store } from '../store/store';

export default {
    name: 'ItemCardRealEstate',
    components: {
        
    },
    props: {
        popupItem: null
    },
    data() {
        return {

        }
    },
    methods: {
        openExternalLink() {
            let viewData = {
                viewType: 'ARTICLE_OPEN',
                externalId: this.popupItem.id,
                externalTitle: this.popupItem.title,
                externalUrl: this.popupItem.url
            };
            eventBus.$emit('articleOpen', viewData);
        }
    }
}

</script>

<style scoped>
.ecm-item-card-address {
    font-size: 1rem;
    font-weight: bold;
    margin: 1rem 1rem .5rem 1rem;
}
.ecm-item-card-city {
    font-size: 1rem;
    color: #666;
    margin: 0 1rem 1rem 1rem;
}
.ecm-item-card-price-and-size {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 1.5rem;
    font-weight: bold;
    margin: .5rem 1rem;
}
.ecm-item-room-configuration,
.ecm-item-building-type {
    font-size: 1rem;
    color: #666;
    margin: .5rem 1rem 1rem 1rem;
}
.ecm-item-room-configuration {
    margin-bottom: .5rem;
}
.ecm-item-card-read-more {
    font-size: .875rem;
    font-weight: bold;
    color: var(--km-theme-color);
    text-align: center;
    margin-bottom: 1rem;
}
</style>
